export default __webpack_public_path__ + "static/benefitImage3-7080227388a2e7575062b0c61efd9349.webp";